import {store} from '@/stores'
import {SET_HEADER} from '@/action-types/header'

export const setHeader = (payload:any)=>{
  store.dispatch({
    type: SET_HEADER,
    payload
  })
}